import './app-nav.scss';

import * as gzAppNavDirective from './app-nav.directive';
import * as gzAppNavService from './app-nav.service';

export default angular.module('gz.appNav', [
  'ui.router',
  'ct.ui.router.extras.future',
  'gazelle.components.go',
])
  .directive(gzAppNavDirective.name, gzAppNavDirective.default)
  .factory(gzAppNavService.name, gzAppNavService.default)
  .name;
